import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import "./Footer.css"

const Footer = () => {
    const newDate = new Date().getFullYear();

    return (
        <footer className='footer-glass'>
            <div className='footer-content'>
                <div className='footer-info'>
                    <h3>Areeb Ahmed</h3>
                    <div className='footer-contact'>
                        <a href="mailto:areebahmedwork@gmail.com" className="contact-link">
                            <i className="fa-solid fa-envelope"></i>
                            areebahmedwork@gmail.com
                        </a>
                        <a href="tel:+919582176784" className="contact-link">
                            <i className="fa-solid fa-phone"></i>
                            +91 9582176784
                        </a>
                    </div>
                </div>

                <div className='social-icons-container'>
                    <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip id="linkedin-tooltip">LinkedIn</Tooltip>}
                    >
                        <a href="https://www.linkedin.com/in/areeb-ahmed-7675541b8/" target="_blank" rel="noreferrer" className="social-icon-btn">
                            <i className='fab fa-linkedin'></i>
                        </a>
                    </OverlayTrigger>

                    <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip id="github-tooltip">GitHub</Tooltip>}
                    >
                        <a href="https://github.com/areeb1899" target="_blank" rel="noreferrer" className="social-icon-btn">
                            <i className='fab fa-github'></i>
                        </a>
                    </OverlayTrigger>
                </div>

                <div className="copyright-text">
                    &copy; {newDate} Areeb Ahmed. All rights reserved.
                </div>
            </div>
        </footer>
    )
};

export default Footer;
